// **  Initial State
const initialState = {
  confirmationModal: {
    isVisible: false,
    title: '',
    action: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
  case 'TOGGLE_CONFIRMATION_MODAL':
    return {
      ...state,
      confirmationModal: {
        isVisible: action.payload.isVisible,
        title: action.payload.title,
        action: action.payload.action,
      },
    };

  default:
    return state;
  }
};
